'use client';

import { useState } from 'react';
import { Modal, ModalContent } from '@paypoteam/ui-components';

import ContactSection from '@/components/sections/ContactSection';
import ImagesItemsSection from '@/components/sections/ImagesItemsSection';
import ItemsContainerSection from '@/components/sections/ItemsContainerSection';

import { POPUP_CONFIG_PL } from '@/static/content/pl/start/popup';
import { POPUP_CONFIG_RO } from '@/static/content/ro/start/popup';

const PopupContent = () => {
    const [isModalOpen, setIsModalOpen] = useState(true);

    const CONFIG =
        process.env.NEXT_PUBLIC_APP_COUNTRY === 'RO'
            ? POPUP_CONFIG_RO
            : POPUP_CONFIG_PL;

    return (
        <Modal
            open={isModalOpen}
            onOpenChange={() => setIsModalOpen(false)}
        >
            <ModalContent
                size={'s'}
                title={CONFIG.modalTitle}
                isCloseButtonVisible
                isFullOnMobile
                className="h-100vh !max-h-[100%]"
            >
                <ItemsContainerSection {...CONFIG.orderedCardSection} />

                <ImagesItemsSection config={CONFIG.imagesItemsSection} />

                <ContactSection config={CONFIG.contactSection} />
            </ModalContent>
        </Modal>
    );
};

export default PopupContent;
